<template>
  <div id="Wrapper">
    <Header :siteInfo="siteInfo"/>
    <div class="main_container">
      <Sidebar :siteInfo="siteInfo"/>
      <SettingCamDetailsComponent v-if="siteInfo !== null && cameraInfo !== null" :siteInfo="siteInfo" :cameraInfo="cameraInfo"/>
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import SettingCamDetailsComponent from '../../components/main/SettingCamDetailsComponent'

export default {
  name: 'SettingCamDetails',
  data: function(){
    return {
    }
  },
  props:{
    siteInfo:{
      type: Array
    },
    cameraInfo:{
      type: Array
    },
  },
  components:{
    Header,
    Sidebar,
    SettingCamDetailsComponent
  },
}
</script>
<style lang="scss">
</style>